import type { AuthRepository } from '@contexts/auth/domain';
import type { UseCase } from '@contexts/shared/application';
import { stringValueObject } from '@contexts/shared/domain';

export type ChangePasswordInput = {
	password: string;
};

export type ChangePasswordUseCase = UseCase<ChangePasswordInput, void>;

export function changePasswordBuilder(authRepository: AuthRepository): ChangePasswordUseCase {
	return async function changePassword(input: ChangePasswordInput): Promise<void> {
		const password = stringValueObject().validate('password', input.password);

		return authRepository.changePassword(password);
	};
}
